import React, {PureComponent} from 'react';
import autobind from 'autobind-decorator';
import {FormControl} from 'react-bootstrap';

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";

@SurveyFormInputEnhance
export class SurveyFormInputText extends PureComponent {
    @autobind
    change(e) {
        const { SurveyFormInput } = this.props;

        SurveyFormInput.Change(answer => ({ ...answer, valueText: e.target.value }));
    }

    render() {
        const { SurveyFormInput, EditMode } = this.props;
        const answer = SurveyFormInput.GetAnswer();

        return EditMode ?
            <FormControl
                className="sb-survey-form-input-text"
                as="textarea"
                value={answer?.valueText || ""}
                onChange={this.change}
            />:
            <div className="pndlm-line-break">
                {answer?.valueText || ""}
            </div>
        ;
    }
}


